"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProvisioner = void 0;
const sdk_cardinal_1 = require("@journeyapps-platform/sdk-cardinal");
const sdk_deploy_service_1 = require("@journeyapps-platform/sdk-deploy-service");
const sdk_accounts_hub_1 = require("@journeyapps-platform/sdk-accounts-hub");
const sdk_common_1 = require("@journeyapps-platform/sdk-common");
const sdk_cerberus_1 = require("@journeyapps-platform/sdk-cerberus");
const sdk_charging_station_1 = require("@journeyapps-platform/sdk-charging-station");
const sdk_container_depot_1 = require("@journeyapps-platform/sdk-container-depot");
const _ = require("lodash");
const sdk_intercom_1 = require("@journeyapps-platform/sdk-intercom");
class ClientProvisioner {
    constructor(params) {
        this.standardHeaders = async () => {
            const token = await this.options.token_provisioner.provisionHubToken();
            return {
                Authorization: `Bearer ${token}`
            };
        };
        this.provisionChargingStationClient = _.memoize(() => {
            return new sdk_charging_station_1.ChargingStationClient({
                endpoint: this.options.charging_station_url,
                client: (0, sdk_common_1.createWebNetworkClient)({
                    headers: this.standardHeaders
                })
            });
        });
        this.provisionAccountsV5Client = _.memoize(() => {
            return new sdk_accounts_hub_1.AccountsV5Client({
                endpoint: this.options.accounts_hub_url,
                client: (0, sdk_common_1.createWebNetworkClient)({
                    headers: this.standardHeaders
                })
            });
        });
        this.provisionCardinalClient = _.memoize(() => {
            const client = (0, sdk_common_1.createWebNetworkClient)({
                headers: this.standardHeaders
            });
            return new sdk_cardinal_1.CardinalClient({
                endpoint: this.options.cardinal_url,
                client: client
            });
        });
        this.provisionCerberusClient = _.memoize(() => {
            const client = (0, sdk_common_1.createWebNetworkClient)({
                headers: this.standardHeaders
            });
            return new sdk_cerberus_1.Client({
                endpoint: this.options.cerberus_url,
                client: client
            });
        });
        this.provisionContainerDepotClient = _.memoize(() => {
            const client = (0, sdk_common_1.createWebNetworkClient)({
                headers: this.standardHeaders
            });
            return new sdk_container_depot_1.ContainerDepotClient({
                endpoint: this.options.container_depot_url,
                client: client
            });
        });
        this.provisionDeployServiceClient = _.memoize(() => {
            const client = (0, sdk_common_1.createWebNetworkClient)({
                headers: this.standardHeaders
            });
            return new sdk_deploy_service_1.DeployServiceClient({
                endpoint: this.options.deploy_service_url,
                client: client
            });
        });
        this.provisionIntercomClient = _.memoize(() => {
            const client = (0, sdk_common_1.createWebNetworkClient)({
                headers: this.standardHeaders
            });
            return new sdk_intercom_1.IntercomClient({
                endpoint: this.options.intercom_url,
                client: client
            });
        });
        this.options = params;
    }
}
exports.ClientProvisioner = ClientProvisioner;
